import { render, staticRenderFns } from "./RecepcionesActividadPantalla.vue?vue&type=template&id=77bcc2e1&"
import script from "./RecepcionesActividadPantalla.vue?vue&type=script&lang=ts&"
export * from "./RecepcionesActividadPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('77bcc2e1', component.options)
    } else {
      api.reload('77bcc2e1', component.options)
    }
    module.hot.accept("./RecepcionesActividadPantalla.vue?vue&type=template&id=77bcc2e1&", function () {
      api.rerender('77bcc2e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Recepcion/RecepcionesActividadPantalla.vue"
export default component.exports